<template>
  <transition
    class="accordion-base"
    name="accordion-content"
    @enter="onEnter"
    @after-enter="onAfterEnter"
    @leave="onLeave"
    @after-leave="onAfterLeave"
  >
    <div
      v-show="isOpen"
    >
      <slot name="content" />
    </div>
  </transition>
</template>

<script>

  export default {
    name: 'Accordion',
    props: {
      isOpen: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onEnter (el) {
        el.style.height = '0';
        el.style.overflow = 'hidden';

        el.offsetHeight;
        el.style.height = `${el.scrollHeight}px`;
      },
      onAfterEnter (el) {
        el.style.height = 'auto';
        el.style.overflow = '';
      },
      onLeave (el) {
        el.style.height = `${el.scrollHeight}px`;
        el.style.overflow = 'hidden';

        el.offsetHeight;
        el.style.height = '0';
      },
      onAfterLeave (el) {
        el.style.height = '';
        el.style.overflow = '';
      }
    }
  };
</script>

<style scoped>
  .accordion-base {
    width: 100%;
  }

  .accordion-content-enter-active,
  .accordion-content-leave-active {
    transition: height 300ms cubic-bezier(0.4, 0, 0.2, 1);
  }
</style>
